<template>
  <div v-if="loading" class="row">
    <div class="col-12 text-center mt-5 mb-5">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
  </div>
  <div v-else>
    <div class="row">
      <div class="col-12 select-area">
        <b-form-group
          :label="`${this.$t('reports.comparativeCategories.profileLabel')}:`"
          label-for="select-profile"
        >
          <b-form-select
            id="select-profile"
            v-model="selectedProfile"
            :options="optionsProfiles"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          :label="`${this.$t('reports.comparativeCategories.categoryLabel')}:`"
          label-for="select-category"
        >
          <b-form-select
            id="select-category"
            v-model="selectedCategory"
            :options="optionsCategories"
            @change="listSubCategories"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          v-if="selectedCategory && optionsSubcategories.length > 1"
          :label="`${$t('reports.comparativeCategories.subcategoryLabel')}:`"
          label-for="select-subcategory"
        >
          <b-form-select
            id="select-subcategory"
            v-model="selectedSubcategory"
            :options="optionsSubcategories"
          ></b-form-select>
        </b-form-group>
        <b-form-group v-if="selectedCategory" class="pt30">
          <b-button
            id="analyze-button"
            @click="analyzeChart"
            :title="`${$t('reports.comparativeCategories.analyzeLabel')}`"
          >
            {{ $t('reports.comparativeCategories.analyzeLabel') }}
          </b-button>
        </b-form-group>
      </div>
      <div>
        <template v-for="(tagItem, index) in tagsFilters">
          <idx-chips :key="index" style="margin-left: 24px">
            <span
              >{{ tagItem.profile[0].toUpperCase() + tagItem.profile.substr(1) }}-{{ tagItem.category }}-{{
                tagItem.subCategory
              }}</span
            >
            <span class="closebtn" @click="handleRemoveTag(index)"
              >&times;</span
            >
          </idx-chips>
        </template>
      </div>
    </div>
    <div v-if="tagsFilters.length === 0" class="row">
      <div class="col-12 text-center mt-4">
        <p>
          <font-awesome-icon
            :icon="['fas', 'chart-line']"
            style="margin-right: 20px; font-size: 35px"
          />
        </p>
        <h5>
          {{ this.$t('reports.comparativeCategories.reportTitle') }}
        </h5>
        <p>{{ this.$t('reports.comparativeCategories.fillFieldsMsg') }}</p>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12 mt-4">
        <highcharts v-if="!loadingReport" :options="chartOptions"></highcharts>
        <div v-else class="col-12 text-center mt-5 mb-5">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isBefore } from 'date-fns';
import api from '../../../../services/api';
import idxChips from '../../../molecules/idx-chips';
import eventBus from '../../../../eventBus';

export default {
  components: {
    idxChips,
  },
  props: ['accumulated', 'reportPeriod'],
  data: () => ({
    loading: true,
    userAuth: null,
    emptyState: true,
    period: 'daily',
    selectedProfile: null,
    optionsProfiles: [],
    selectedCategory: null,
    optionsCategories: [],
    selectedSubcategory: null,
    optionsSubcategories: [],
    selectedTags: [],
    chartOptions: {},
    yAxisTitle: null,
    chartsValues: [],
    tagsFilters: [
      // {
      //   profile: 'promotor',
      //   category: 'Atendtimento',
      //   idCategory: null,
      //   subCategory: 'subAtendimento',
      //   idSubCategory: null,
      // },
    ],
    notFoundTag: true,
    loadingReport: true,
    listInfoGraph: []
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabels();
    this.changeYAxisTitle();
  },

  async mounted() {
    await this.getCategories();
    this.loading = false;
    eventBus.$on('accumulated-report', (checked) => {
      this.accumulated = checked;

      const data = this.listInfoGraph;

      switch (this.reportPeriod) {
        case 'daily':
          this.chartOptions.xAxis.categories = data.daily ? data.daily.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = data.daily ? data.daily.npsAccumulated : [];
          } else {
            this.chartOptions.series = data.daily ? data.daily.nps : [];
          }
          break;
        case 'week':
          this.chartOptions.xAxis.categories = data.weekly ? data.weekly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = data.weekly ? data.weekly.npsAccumulated : [];
          } else {
            this.chartOptions.series = data.weekly ? data.weekly.nps : [];
          }
          break;
        case 'month':
          this.chartOptions.xAxis.categories = data.monthly ? data.monthly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = data.monthly ? data.monthly.npsAccumulated : [];
          } else {
            this.chartOptions.series = data.monthly ? data.monthly.nps : [];
          }
          break;
        case 'quarter':
          this.chartOptions.xAxis.categories = data.quarterly ? data.quarterly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = data.quarterly ? data.quarterly.npsAccumulated : [];
          } else {
            this.chartOptions.series = data.quarterly ? data.quarterly.nps : [];
          }
          break;
        default:
          break;
      }
    });
    eventBus.$on('data-source', () => {
      this.getInfoGraph();
      // switch (this.reportPeriod) {
      //   case 'day':
      //     this.period = 'daily';
      //     break;
      //   case 'week':
      //     this.period = 'weekly';
      //     break;
      //   case 'month':
      //     this.period = 'monthly';
      //     break;
      //   case 'quarter':
      //     this.period = 'quarterly';
      //     break;
      //   default:
      //     break;
      // }
    });
    eventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });
  },

  methods: {
    changeLabels() {
      this.optionsCategories = [
        {
          value: null,
          text: this.$t('reports.comparativeCategories.selCategoryLabel'),
        },
      ];

      if (this.myMetric.indexOf('nps') >= 0) {
        this.optionsProfiles = [
          {
            value: null,
            text: this.$t('reports.comparativeCategories.selProfileLabel'),
          },
          {
            value: 'promoter',
            text: this.$t('reports.comparativeCategories.promoterLabel'),
          },
          {
            value: 'neutral',
            text: this.$t('reports.comparativeCategories.neutralLabel'),
          },
          {
            value: 'detractor',
            text: this.$t('reports.comparativeCategories.detractorLabel'),
          },
        ];
      } else {
        this.optionsProfiles = [
          {
            value: null,
            text: this.$t('reports.comparativeCategories.selProfileLabel'),
          },
          {
            value: 'promoter',
            text: '4-5',
          },
          {
            value: 'neutral',
            text: '3',
          },
          {
            value: 'detractor',
            text: '1-2',
          },
        ];
      }

      this.chartOptions = {
        chart: {
          type: 'line',
        },
        title: {
          text: this.$t('reports.comparativeCategories.reportTitle'),
        },
        xAxis: {
          categories: [],
        },
        yAxis: {
          title: {
            text: this.yAxisTitle,
          },
        },
        plotOptions: {
          line: {
            dataLabels: {
              enabled: true,
            },
            enableMouseTracking: false,
          },
        },
        series: [],
      };
    },

    clearFieldsSelected() {
      this.selectedProfile = null;
      this.selectedCategory = null;
      this.selectedSubcategory = null;
    },

    async listSubCategories() {
      if (this.selectedCategory) {
        try {
          const response = await api.get(
            `/subcategories/${this.selectedCategory}`,
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );

          this.optionsSubcategories = [];

          this.optionsSubcategories.push(
            {
              value: null,
              text: this.$t('reports.comparativeCategories.selSubcategoryLabel'),
            },
          );

          for (let i = 0; i < response.data.length; i += 1) {
            this.optionsSubcategories.push({
              value: response.data[i]._id,
              text: response.data[i].name,
            });
          }
        } catch (error) {
          window.console.log(error);
        }
      }
    },

    async getCategories() {
      this.loading = true;

      this.optionsCategories = [];

      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
          },
        });

        this.optionsCategories = [
          {
            value: null,
            text: this.$t('reports.comparativeCategories.selCategoryLabel'),
          },
        ];

        for (let i = 0; i < response.data.length; i += 1) {
          this.optionsCategories.push({
            value: response.data[i]._id,
            text: response.data[i].name,
          });
        }
      } catch (error) {
        window.console.log(error);
      }

      this.loading = false;
    },

    returnTagNameCategoryAndSubCategory(type, id) {
      if (type === 'category') {
        if (id) {
          const category = this.optionsCategories.find(
            (obj) => obj.value === id,
          );

          if (category !== undefined) {
            return category;
          }
          return 'Todos';
        }
        return 'Todos';
      } else if (type === 'subCategory') {
        if (id) {
          const subCategory = this.optionsSubcategories.find(
            (obj) => obj.value === id,
          );

          if (subCategory !== undefined) {
            return subCategory;
          }
          return 'Todos';
        }

        return 'Todos';
      }

      return 'Todos';
    },

    returnGrayTags() {
      if (this.tagsFilters.length > 0) {
        for (let i = 0; i < this.tagsFilters.length; i += 1) {
          if (
            this.selectedProfile === this.tagsFilters[i].profile &&
            this.selectedCategory === this.tagsFilters[i].idCategory &&
            this.selectedSubcategory === this.tagsFilters[i].idSubCategory
          ) {
            this.notFoundTag = false;
          }
        }
      }

      if (this.notFoundTag) {
        const tagCategory = this.returnTagNameCategoryAndSubCategory(
          'category',
          this.selectedCategory,
        );
        const tagSubCategory = this.returnTagNameCategoryAndSubCategory(
          'subCategory',
          this.selectedSubcategory,
        );

        this.tagsFilters.push({
          profile: this.selectedProfile ? this.selectedProfile : 'Todos',
          category: tagCategory.text ? tagCategory.text : tagCategory,
          idCategory: tagCategory.value ? tagCategory.value : null,
          subCategory: tagSubCategory.text
            ? tagSubCategory.text
            : tagSubCategory,
          idSubCategory: tagSubCategory.value ? tagSubCategory.value : null,
        });
      }
    },

    async getInfoGraph() {
      this.loadingReport = true;
      const response = await api.get(
        `/reports/comparative-categories/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            actionId:
              this.myActionsIds.length === 0
                ? null
                : this.myActionsIds.join(','),
            metric: this.myMetric ? this.myMetric : null,
            startDate: this.calendarDates.start
              ? this.calendarDates.start
              : null,
            endDate: this.calendarDates.end ? this.calendarDates.end : null,
            ih1:
              this.myHierarchies1.length === 0
                ? null
                : this.myHierarchies1.join(','),
            ih2:
              this.myHierarchies2.length === 0
                ? null
                : this.myHierarchies2.join(','),
            groupId: this.actionGroupData._id,
            profile: this.selectedProfile,
            category: this.selectedCategory,
            subcategory: this.selectedSubcategory,
            tagsFilters: this.tagsFilters,
          },
        },
      );

      this.listInfoGraph = response.data;

      // const categories = ['10/07/2023', '11/07/2023', '12/07/2023', '13/07/2023'];
      // const npsAccumulated = [
      //   {
      //     name: 'Promotor - Atendimento - Todos',
      //     data: [3, 4, 5, 10],
      //   },
      //   {
      //     name: 'Promotor - Bko - Todos',
      //     data: [1, 10, 7, 20],
      //   },
      // ];
      // const npsNotAccumulated = [
      //   {
      //     name: 'Promotor - Atendimento - Todos',
      //     data: [3, 4, 7],
      //   },
      //   {
      //     name: 'Promotor - Bko - Todos',
      //     data: [0, 0, 0],
      //   },
      // ];

      switch (this.reportPeriod) {
        case 'daily':
          this.chartOptions.xAxis.categories = response.data.daily ? response.data.daily.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = response.data.daily ? response.data.daily.npsAccumulated : [];
          } else {
            this.chartOptions.series = response.data.daily ? response.data.daily.nps : [];
          }
          break;
        case 'week':
          this.chartOptions.xAxis.categories = response.data.weekly ? response.data.weekly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = response.data.weekly ? response.data.weekly.npsAccumulated : [];
          } else {
            this.chartOptions.series = response.data.weekly ? response.data.weekly.nps : [];
          }
          break;
        case 'month':
          this.chartOptions.xAxis.categories = response.data.monthly ? response.data.monthly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = response.data.monthly ? response.data.monthly.npsAccumulated : [];
          } else {
            this.chartOptions.series = response.data.monthly ? response.data.monthly.nps : [];
          }

          // this.chartOptions.xAxis.categories = categories;

          // if (this.accumulated) {
          //   this.chartOptions.series = npsAccumulated;
          // } else {
          //   this.chartOptions.series = npsNotAccumulated;
          // }
          break;
        case 'quarter':
          this.chartOptions.xAxis.categories = response.data.quarterly ? response.data.quarterly.categories : [];

          if (this.accumulated) {
            this.chartOptions.series = response.data.quarterly ? response.data.quarterly.npsAccumulated : [];
          } else {
            this.chartOptions.series = response.data.quarterly ? response.data.quarterly.nps : [];
          }
          break;
        default:
          break;
      }

      this.loadingReport = false;
    },

    async analyzeChart() {
      this.listSubCategories();
      this.returnGrayTags();

      if (this.notFoundTag) {
        this.getInfoGraph();
      }

      this.selectedCategory = null;
      this.selectedSubcategory = null;
      this.selectedProfile = null;

      // if (
      //   this.selectedProfile ||
      //   this.selectedCategory ||
      //   this.selectedSubcategory ||
      //   this.tagsFilters.length > 0
      // ) {
      //   this.listSubCategories();
      //   this.returnGrayTags();

      //   if (this.notFoundTag) {
      //     this.getInfoGraph();
      //   }

      //   this.selectedCategory = null;
      //   this.selectedSubcategory = null;
      //   this.selectedProfile = null;
      // }
    },

    getCategoryName(id) {
      for (let i = 0; i < this.optionsCategories.length; i += 1) {
        if (id === this.optionsCategories[i].value) {
          return this.optionsCategories[i].text;
        }
      }
      return '';
    },

    getSubcategoryName(id) {
      for (let i = 0; i < this.optionsSubcategories.length; i += 1) {
        if (id === this.optionsSubcategories[i].value) {
          return this.optionsSubcategories[i].text;
        }
      }
      return '';
    },

    getTagInfo(tag) {
      // let retText = '';
      // if (tag && tag.profile) {
      //   retText = `${retText}${this.getProfile(tag.profile)} - `;
      // } else {
      //   retText = `${retText}${this.$t(
      //     'reports.comparativeCategories.allLabel',
      //   )} - `;
      // }
      // if (tag && tag.category) {
      //   retText = `${retText}${this.getCategoryName(tag.category)} - `;
      // }
      // if (tag && tag.subcategory) {
      //   retText = `${retText}${this.getSubcategoryName(tag.subcategory)}`;
      // } else {
      //   retText = `${retText}${this.$t(
      //     'reports.comparativeCategories.allLabel',
      //   )}`;
      // }
      // return `${retText}`;
    },

    handleRemoveTag(index) {
      this.tagsFilters.splice(index, 1);
      this.getInfoGraph();
    },

    updateChartCategories() {},

    updateChartSeries() {},

    convertDate(date) {
      const dates = date.split('/');
      return `${dates[1]}/${dates[0]}/${dates[2]}`;
    },

    changeYAxisTitle() {
      /*
      if (this.myMetric.indexOf('nps') >= 0) {
        this.yAxisTitle = 'NPS';
      } else if (this.myMetric.indexOf('ces') >= 0) {
        this.yAxisTitle = 'CES';
      } else if (this.myMetric.indexOf('csat') >= 0) {
        this.yAxisTitle = 'CSAT';
      }
      */
      this.yAxisTitle = `%${this.$t(
        'reports.comparativeCategories.yAxisLabel',
      )}`;
      this.chartOptions.yAxis.title.text = this.yAxisTitle;
    },
  },

  watch: {
    tagsFilters: async function watchTagFilters() {
      // this.getInfoGraph();
    },

    actionGroupData: async function watchActionGroupData() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    // myActionId: async function watchMyActionId() {
    //   await this.getCategories();
    // },

    myActionsIds: async function watchMyActionsIds() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    myIh1: async function watchMyIh1() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    myHierarchies1: async function watchMyHierarchies1() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    myHierarchies2: async function watchMyHierarchies2() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    myIh2: async function watchMyIh2() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    calendarDates: async function watchDates() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },

    myMetric: async function watchMyMetric() {
      this.clearFieldsSelected();
      this.getCategories();
      this.changeYAxisTitle();
      this.getInfoGraph();
    },
    'indicatorData.value': async function watchIndicatorDataValue() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.clearFieldsSelected();
      this.getCategories();
      this.getInfoGraph();
    },
  },

  beforeDestroy() {
    eventBus.$off('accumulated-report');
    eventBus.$off('data-source');
  },
};
</script>

<style scoped lang="scss">
.select-area {
  display: flex;
  flex-direction: row;

  select {
    width: 215px;
    margin-right: 15px;
  }
}
.pt30 {
  padding-top: 30px;
}
#analyze-button {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/comparative-categories/index.vue